import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withIntl } from 'ha/i18n';
import {
  isMapAutoSearchEnabled,
  isMapOutdated,
  isMobileMapOpen,
} from 'ha/pages/Search/selectors';
import { onMapUpdate, toggleMapAutoSearch } from 'ha/pages/Search/actions';

import SearchMapAutoRefresh from 'ha/pages/Search/components/SearchMapAutoRefresh';
import { createStructuredSelector } from 'reselect';

const mapStateToProps = createStructuredSelector({
  isAutoSearchEnabled: isMapAutoSearchEnabled,
  isOutdated: isMapOutdated,
  isMobileMapOpen,
});

const mapDispatchToProps = {
  onMapUpdate,
  toggleMapAutoSearch,
};

export default compose(
  withIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SearchMapAutoRefresh);
